import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { salonInfo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Location', path: '/location' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b-2 border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="/logo-light.jpeg" 
              alt={salonInfo.name}
              className="h-14 w-auto object-contain group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <Link key={item.path} to={item.path}>
                <Button
                  variant="ghost"
                  className={`text-base font-medium transition-all duration-300 ${
                    isActive(item.path)
                      ? 'text-[#3D7A8C] bg-[#3D7A8C]/10'
                      : 'text-gray-700 hover:text-[#3D7A8C] hover:bg-[#3D7A8C]/10'
                  }`}
                >
                  {item.name}
                </Button>
              </Link>
            ))}
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <a href={`tel:${salonInfo.phone}`}>
              <Button className="bg-[#3D7A8C] hover:bg-[#356A7A] text-white shadow-lg hover:shadow-xl transition-all duration-300">
                <Phone className="mr-2 h-4 w-4" />
                Call Us
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-[#3D7A8C] transition-colors"
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t-2 border-gray-100">
            <nav className="flex flex-col gap-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                >
                  <Button
                    variant="ghost"
                    className={`w-full justify-start text-base font-medium transition-all duration-300 ${
                      isActive(item.path)
                        ? 'text-[#3D7A8C] bg-[#3D7A8C]/10'
                        : 'text-gray-700 hover:text-[#3D7A8C] hover:bg-[#3D7A8C]/10'
                    }`}
                  >
                    {item.name}
                  </Button>
                </Link>
              ))}
              <div className="flex flex-col gap-2 mt-4 pt-4 border-t-2 border-gray-100">
                <a href={`tel:${salonInfo.phone}`} onClick={() => setIsMenuOpen(false)}>
                  <Button className="w-full bg-[#3D7A8C] hover:bg-[#356A7A] text-white">
                    <Phone className="mr-2 h-4 w-4" />
                    Call Us
                  </Button>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
